module.exports = __webpack_public_path__ + "7c5ded5b18ae2aca254a870860e6a757.svg";